import React from 'react'

// Only use lazy loading for components when loaded via MfeComponent

export const BillingForm = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-billing" */ '@jarvis/react-billing'
  ).then((mod) => ({
    default: mod.BillingForm
  }))
)

export const ShippingForm = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-shipping" */ '@jarvis/react-shipping'
  ).then((mod) => ({
    default: mod.ShippingForm
  }))
)

export const ManualPrinterClaim = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-manual-printer-claim" */ '@jarvis/react-manual-printer-claim'
  ).then((mod) => ({
    default: mod.ManualPrinterClaim
  }))
)

export const PlanSelector = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-plans" */ '@jarvis/react-instant-ink-plans'
  ).then((mod) => ({
    default: mod.PlanSelector
  }))
)

export const ConsumerPlanSelector = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-plans" */ '@jarvis/react-instant-ink-plans'
  ).then((mod) => ({
    default: mod.ConsumerPlanSelector
  }))
)

export const PlanSelectorV3 = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-plans" */ '@jarvis/react-instant-ink-plans'
  ).then((mod) => ({
    default: mod.PlanSelectorV3
  }))
)

export const PlanTypeSelector = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-plans" */ '@jarvis/react-instant-ink-plans'
  ).then((mod) => ({
    default: mod.PlanTypeSelector
  }))
)

export const FreeTerms = React.lazy(() =>
  import(
    /* webpackChunkName: "ii-client-react-instant-ink-ui-legos" */ '@ii-central/react-instant-ink-ui-legos'
  ).then((mod) => ({
    default: mod.FreeTerms
  }))
)

export const CountrySelector = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-country-selector" */ '@jarvis/react-instant-ink-country-selector'
  ).then((mod) => ({
    default: mod.CountrySelector
  }))
)

export const GapHandler = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-country-selector" */ '@jarvis/react-instant-ink-country-selector'
  ).then((mod) => ({
    default: mod.GapHandler
  }))
)

export const LanguageSelector = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-country-selector" */ '@jarvis/react-instant-ink-country-selector'
  ).then((mod) => ({
    default: mod.LanguageSelector
  }))
)

export const AutomaticRenewalNotice = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-automatic-renewal-notice" */ '@jarvis/react-instant-ink-automatic-renewal-notice'
  ).then((mod) => ({
    default: mod.AutomaticRenewalNotice
  }))
)

export const AutomaticFirmwareUpdate = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-automatic-firmware-update" */ '@jarvis/react-instant-ink-automatic-firmware-update'
  ).then((mod) => ({
    default: mod.AutomaticFirmwareUpdate
  }))
)

export const LearnMore = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-learn-more" */ '@jarvis/react-instant-ink-learn-more'
  ).then((mod) => ({
    default: mod.LearnMore
  }))
)

export const DeeplinkWebEnrollment = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-deeplink" */ '@jarvis/react-instant-ink-deeplink'
  ).then((mod) => ({
    default: mod.WebEnrollment
  }))
)

export const FaqViewer = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-faq" */ '@jarvis/react-instant-ink-faq'
  ).then((mod) => ({
    default: mod.FaqViewer
  }))
)

export const ErrorNotice = React.lazy(() =>
  import(
    /* webpackChunkName: "jarvis-react-instant-ink-error-notice" */ '@jarvis/react-instant-ink-error-notice'
  ).then((mod) => ({
    default: mod.ErrorNotice
  }))
)
